<style>
	.vm2_wrapper{
    z-index:900 !important;
	}
	.secure{
		-webkit-text-security: disc;
	}
</style> 

<template>
	<span>
		<span v-if="status == 1" class="badge bg-green"><i class="fa fa-check-circle"></i> sikeresen aláírva</span>
		<span v-else-if="status == 0">
				<button v-if="!hide_sign_button" v-b-modal="'signatureSimpleModal_'+user_id" class="btn btn-warning" :disabled="disabled_sign">Aláírás <i class="fa fa-signature"></i></button>
				<span v-if="hide_sign_button" class="badge bg-red"><i class="fa fa-times"></i> Nem tud aláírni!</span>
		</span>
		<b-modal :id="'signatureSimpleModal_'+user_id" cancel-variant="default" ok-title="Aláírás" cancel-title="Mégse" @ok="sign" @shown="$refs['pinsimpleinput_'+user_id].focus()">
			<template slot="modal-header">
				<h4 class="modal-title">Aláírás</h4>
				<a class="btn-close" @click="$bvModal.hide('signatureSimpleModal_'+user_id)"></a>
			</template>
			<Loading v-if="loading" title="Aláírás folyamatban"></Loading>
			<form @submit.prevent="sign()" v-else>
				<p v-if="text">{{text}}</p>
				<label class="form-label">Pin:</label>
				<input class="form-control secure" :ref="'pinsimpleinput_'+user_id" maxlength="6" type="text" v-model="pin" required :class="{'is-invalid' : errors.pin}">
				<div class="invalid-feedback d-block" v-if="errors.pin">
					{{ errors.pin[0] }}
				</div>
				<button type="submit" class="d-none"></button>
			</form>
		</b-modal>
	</span>
</template>

<script>
	import Loading from '../components/Loading';
	import User from "../apis/User";
export default {
	components: {
		Loading,
	},
	props: {user_id: Number, hideSignButton: Boolean, text: String,disabled_sign: {type:Boolean,default:false}},
	data() {
		return {
			pin:null,
			status: 0,
			errors: [],
			loading:false,
			hide_sign_button:false,
		}
	},
	computed: {
		submitObject(){
			return {
				user_id: this.user_id,
				pin: this.pin
			}
		}
	},
	created(){
		if(this.hideSignButton){
			this.hide_sign_button = true;
		}
	},
	watch:{
		hideSignButton: function(val){
			this.hide_sign_button = val;
		},
	},
	methods:{
		resetStatus(){
			this.$set(this,'status',0);
			this.pin = null;
		},		
		sign(bvModalEvt){
			this.loading = true;
			if(bvModalEvt){
				bvModalEvt.preventDefault()
			}
			User.validatePin(this.submitObject)
			.then(() => {
				this.status = 1;
				this.$bvModal.hide('signatureSimpleModal_'+this.user_id);
				this.$emit('signed');
			})
			.catch(error => {
				if(error.response.data.errors){
					this.errors = error.response.data.errors;
				}
				this.$set(this,'loading',false);
				this.$nextTick(() => {
					this.$nextTick(() => {
						this.$refs['pinsimpleinput_'+this.user_id].focus()
					})
				})
			}).finally(() => {
				this.$set(this,'loading',false);
			});
		},
	}
};
</script>
